export { default as App } from "../App";

export { default as AuditTrail } from "../components/audit-trail/page";

export { default as PromoCodePage } from "../containers/promo-code";

export { default as DecisionsSummary } from "../containers/decisions-summary";
export { default as CeoDecisions } from "../containers/ceo-decisions";
export { default as PDDecisions } from "../containers/PDDecisions";
export { default as PMDecisions } from "../containers/PMDecisions";
export { default as OperationsDecisions } from "../containers/operations-decisions";
export { default as FinanceDecisions } from "../containers/finance-decisions";

export { default as Analysis } from "../components/analysis/Analysis";
export { default as BusinessCase } from "../components/dashboard/BusinessCase";

export { default as MarketAnalysis } from "../containers/market-analysis";
export { default as CompetitiveAnalysis } from "../containers/competitive-analysis";
export { default as EconomicAnalysis } from "../containers/economic-analysis";
export { default as FinancialAnalysis } from "../containers/financial-analysis";

export { default as Results } from "../containers/Results";

export { default as KnowledgeBase } from "../containers/KnowledgeBase";

export { default as FNAnalysisFNStatements } from "../containers/FNAnalysisFNStatements";
export { default as FNAnalysisFNStatementsIncomeStatement } from "../containers/FNAnalysisFNStatementsIncomeStatement";
export { default as FNAnalysisFNStatementsCashFlow } from "../containers/FNAnalysisFNStatementsCashFlow";
export { default as FNAnalysisFNStatementsBalanceSheet } from "../containers/FNAnalysisFNStatementsBalanceSheet";

export { default as WelcomePage } from "../containers/welcome-page";
export { default as LoginPage } from "../containers/login-page";
export { default as RegisterPage } from "../containers/register-page";
export { default as JoinPage } from "../containers/join-page";
export { default as ResetPasswordPage } from "../containers/reset-password-page";
export { default as AccountVerify } from "../services/account-verify";
export { default as ResetPassword } from "../services/reset-password";

export { default as TeamReports } from "../containers/team-reports";

export { default as InstructorDashboard } from "../instructor/containers/dashboard";
export { default as InstructorCourseManagement } from "../instructor/containers/course-management";
export { default as InstructorGameManagement } from "../instructor/containers/game-management";
export { default as InstructorRoundManagement } from "../instructor/containers/round-management";
export { default as InstructorTeamManagement } from "../instructor/containers/team-management";
export { default as InstructorPerformanceFeedback } from "../instructor/containers/performance-feedback";
export { default as InstructorPeerFeedback } from "../instructor/containers/peer-feedback";
export { default as InstructorPeerReview } from "../instructor/containers/peer-review";
export { default as InstructorTeamsRoles } from "../instructor/containers/teams-roles";
export { default as InstructorRoundAdmin } from "../instructor/containers/round-admin";
export { default as InstructorOnboardingPage } from 'instructor/containers/onboarding';
export { default as InstructorGoalsAndTargets } from 'instructor/containers/goals-and-targets';
export { default as InstructorGrading } from 'instructor/containers/grading';
export { default as Dashboard } from "../components/dashboard/Dashboard";
export { default as GetStarted } from "components/get-started/page";

export { default as MyProfilePage } from "components/profile";
export { default as OnboardingPage } from 'components/onboarding/OnboardingPage';
export { default as RoundTriviaPage } from 'components/onboarding/RoundTriviaPage';
export { default as PerformanceFeedback } from 'components/performance-feedback/index';

export { default as GoalsAndTargets } from 'components/goals-and-targets/index';
export { default as PeerFeedback } from 'components/peer-feedback/index';
export { default as PeerReview } from 'components/peer-review/index';
export { default as StartPage } from 'components/navigation/start';



// WEBPACK FOOTER //
// ./src/routes/routes.js